//NBL1_Official Pages
import rules from "../../Data/Rules"
import functions from "../../Data/Functions"
import settings from "../Settings/NBL1_Settings"

let Countries, CoachingStatus, IndigenousStatus, Clubs, Conference
let TeamNames, Teamids, Associds, PlayerAccred, StaffAccredids,
    OfficialAccredids, NBL1Associations, NBL1Associds
let Constants = {
    mediaTypes: ["Media", "Photographer", "Commentator"],
    mediaRoleid: [17, 18, 19],
    mediaTypesC: ["Media", "Photographer", "Commentator"],
    mediaRoleidC: [17, 18, 19],
    mediaTypesN: ["Media", "Photographer", "Commentator", "Data Scout",
        "NBL Coach", "WNBL Coach", "NBL Staff", "NBL1 Partner"],
    mediaRoleidN: [17, 18, 19, 20, 21, 25, 22, 23],
    mediaConferences: [3032, 3060, 3034, 3031, 3033, 3452],
    mediaConfids: [3478, 3480, 3481, 3479, 3482, 3483],
    mediaAccredids: [6242, 6244, 6243, 6241, 6245, 6247]
}
// NBL1 Media Step Schema
const Load_NBL1_Media_Steps = () => {
    return {
        Portal: '2024 NBL1 Media Accreditiation',
        MainColor: "#f5924c",
        Logo: require(`../../assets/${Conference.logo}`),
        Title: (Conference.Code_id == 3452) ? `<h2>National Accreditation System</h2>`
            : `<h2>Mitsubishi ${Conference.Name} 2024 Media Registration Form</h2>`,
        Description: `I HEREBY APPLY to be registered with ${Conference.Organisation} 
                            for the 2024 ${Conference.Name} season. I acknowledge 
                            that my information will be retained and used by ${Conference.abbrev} 
                            and the NBL to meet its obligations in administering the league and 
                            to ensure the registered person can be contacted when required for Tribunal, 
                            Integrity or COVID related matters.
                            <br><br>
                            All registered persons should note, in accordance with the Basketball Australia 
                            (BA) National Integrity Framework. BA may share personal information relating 
                            to Participants with Betting Operators, law enforcement agencies, government 
                            agencies or other sporting organisations to prevent and investigate match-fixing 
                            incidents.
                            <br>
                            <b>Please note all submitted registrations are PENDING APPROVAL subject to accreditation</b>`,
        steps: [
            //Step 1
            {
                stepno: 1,
                title: 'Personal Details',
                valid: true,
                information: '',
                Model: {},
                Schema: {
                    firstname: {
                        type: 'text',
                        label: 'First Name',
                        outlined: true,
                        dense: true,
                        prependInnerIcon: 'person',
                        rules: [rules.requiredMsg('Firstname is Required')],
                        class: 'mx-1 px-1',
                    },
                    surname: {
                        type: 'text',
                        label: 'Last Name',
                        outlined: true,
                        dense: true,
                        prependInnerIcon: 'person',
                        rules: [rules.requiredMsg('Surname is Required')],
                        class: 'mx-1 px-1'
                    },
                    DOB: {
                        type: 'text',
                        ext: 'date',
                        locale: 'en',
                        label: `Date of Birth (${functions.setDateFormat()})`,
                        outlined: true,
                        dense: true,
                        mask: functions.setDateMask(),
                        rules: [rules.requiredMsg('Date of Birth is Required')],
                        class: 'mx-1 px-1'
                    },
                    email: {
                        OUGid: '3',
                        type: 'email',
                        label: 'Email Address',
                        outlined: true,
                        dense: true,
                        rules: [rules.validEmail, rules.requiredMsg('Email is Required')],
                        prependInnerIcon: 'alternate_email',
                        class: 'mx-1 px-1'
                    },
                    address: {
                        OUGid: '1',
                        type: 'text',
                        label: 'Address',
                        col: 12,
                        outlined: true,
                        dense: true,
                        rules: [rules.requiredMsg('Address is Required')],
                        prependInnerIcon: 'home',
                        class: 'mx-1 px-1'
                    },
                    mobile: {
                        OUGid: '8',
                        type: 'tel',
                        label: 'Phone Number',
                        outlined: true,
                        dense: true,
                        rules: [rules.requiredMsg('Phone Number is Required')],
                        prependInnerIcon: 'phone',
                        mask: "####-###-###",
                        class: 'mx-1 px-1'
                    },
                    organisaton: {
                        OUGid: '3477',
                        type: 'text',
                        label: "Organisation",
                        outlined: true,
                        dense: true,
                        rules: [rules.requiredMsg('Organisation is Required')],
                        class: 'mx-1 px-1',
                    },
                    mediaRole: {
                        OUGid: "346",
                        type: "select",
                        label: "Role",
                        outlined: true,
                        dense: true,
                        class: 'mx-1 px-1',
                        rules: [rules.requiredMsg('Role is Required')],
                        items: Constants.mediaTypes,
                    },
                    gender: {
                        "type": "select",
                        "label": "Gender",
                        outlined: true,
                        dense: true,
                        rules: [rules.requiredMsg('Gender is Required')],
                        class: 'mx-1 px-1',
                        items: rules.Gender,
                    },
                    Photo: {
                        type: 'file',
                        Doc_id: '3367',
                        Doc_Label: 'Profile Picture',
                        label: 'Head Shot',
                        outlined: true,
                        dense: true,
                        col: 12,
                        rules: [rules.requiredMsg('Head Shot is Required'), rules.fileSize()],
                        class: 'mx-1 px-1',
                        Endslot: `This is a new required Media registration item to create 
                                    your accreditation pass which is to be shown for entry to 
                                    the NBL1 venue.`
                    },
                },
                Validity: () => { }
            },
            // Step 2
            {
                stepno: 2,
                title: 'Confirmation',
                valid: true,
                information: `Thank you for your submitted registration for the 2024 NBL1 season.</br>
                            Please note this submitted registration is <b>PENDING APPROVAL</b> from the league and will be reviewed.<br></br>
                            You and your association delegate will receive an email notification once this has been approved by the league.<br></br>
                            <hr><br></br>
                            Please stay up to date with all NBL1 news and information throughout the season on the <a href="https://nbl1.com.au/" target="blank">NBL1 website</a><br></br>`,
                Model: {},
                Schema: {}
            }
        ]
    }
}

export default {

    LoadSchema: async (Parameters) => {
        (Parameters.Conference == 3452) ? Constants.mediaTypes = Constants.mediaTypesN : Constants.mediaTypes = Constants.mediaTypesC;
        (Parameters.Conference == 3452) ? Constants.mediaRoleid = Constants.mediaRoleidN : Constants.mediaRoleid = Constants.mediaRoleidC;

        Conference = settings.ConfDetails.find((ele) => {
            return Parameters.Conference == ele.Code_id;
        })
        Countries = await functions.GetCountries();
        ({
            PlayerAccred, StaffAccredids, OfficialAccredids, NBL1Associations, NBL1Associds
        } = settings.LoadExtAccreds(Conference.Code_id))
        return Load_NBL1_Media_Steps()
    },

}